/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Submitticketsize_Modal_Acknowledgment3Inputs */

const en_coinvestments_submitticketsize_modal_acknowledgment3 = /** @type {(inputs: Coinvestments_Submitticketsize_Modal_Acknowledgment3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand that this is an indicative amount and I am under no obligation to invest`)
};

/**
* | output |
* | --- |
* | "I understand that this is an indicative amount and I am under no obligation to invest" |
*
* @param {Coinvestments_Submitticketsize_Modal_Acknowledgment3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_submitticketsize_modal_acknowledgment3 = /** @type {((inputs?: Coinvestments_Submitticketsize_Modal_Acknowledgment3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Submitticketsize_Modal_Acknowledgment3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_submitticketsize_modal_acknowledgment3(inputs)
});
export { coinvestments_submitticketsize_modal_acknowledgment3 as "coInvestments_submitTicketSize_modal_acknowledgment" }